import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';
import { booking, leg, product, passenger } from '../queries/GET_BOOKING';

export default gql`
  mutation cancelSpecificBookingItems($bookingReference: String!, $itemRefs: [String]!) {
    cancelSpecificBookingItems(bookingReference: $bookingReference, itemRefs: $itemRefs) {
      cancellable
      ${booking}
    }
  }

  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
